export default __webpack_public_path__ + "static/logoticker_essence-d9e25b7fcf55f62ca3ec1c420c907931.svg";